import { Component, computed, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  IonContent,
  IonButton,
  IonIcon,
  IonCard,
  IonCardContent,
  IonSkeletonText,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  chatbubblesOutline,
  bookOutline,
  gridOutline,
  helpCircleOutline,
  peopleCircleOutline,
  peopleOutline,
  personCircleOutline,
  storefrontOutline,
} from 'ionicons/icons';
import { AuthService } from 'src/app/features/auth/auth.service';
import { CreditsService } from 'src/app/features/credits/credits.service';
import { CreditsSummaryComponent } from 'src/app/features/credits/credits-summary.component';
import { environment } from 'src/environments/environment';
import { RecentChat, RecentChatsService } from 'src/app/features/chat/services/recent-chats.service';
import { AppBrandLogoComponent } from 'src/app/features/common/components/app-brand-logo/app-brand-logo.component';
import { MainTabsPreloadService } from 'src/app/features/common/components/main-tabs/main-tabs-preload.service';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';
import { aiChatTitleKey } from 'src/app/features/stories/utils/aiChatTitle';

@Component({
  selector: 're-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  imports: [
    IonIcon,
    IonButton,
    IonContent,
    IonSkeletonText,
    RouterModule,
    IonCard,
    IonCardContent,
    DatePipe,
    AppBrandLogoComponent,
    CreditsSummaryComponent,
    ...TRANSLATE_IMPORTS,
  ],
})
export class HomePage {
  private recentChatsService = inject(RecentChatsService);
  private credits = inject(CreditsService);
  private readonly tabsPreload = inject(MainTabsPreloadService);

  profile = inject(AuthService).profileSignal;
  readonly tabPagesReady = this.tabsPreload.ready;
  version = environment.version;
  recentChats = this.recentChatsService.recentChats;
  /** Una scorciatoia in evidenza + tre chat: oltre questo punto si entra dalla sezione Storie. */
  visibleRecentChats = computed(() => this.recentChats().slice(0, 4));

  constructor() {
    addIcons({
      chatbubblesOutline,
      bookOutline,
      gridOutline,
      helpCircleOutline,
      peopleCircleOutline,
      peopleOutline,
      personCircleOutline,
      storefrontOutline,
    });
  }

  ionViewWillEnter(): void {
    void this.recentChatsService.validateAgainstServer();
    void this.credits.refreshWallet();
  }

  recentChatIcon(kind: RecentChat['kind']): string {
    switch (kind) {
      case 'narrator':
        return 'book-outline';
      case 'archivist':
        return 'help-circle-outline';
      case 'inn':
        return 'storefront-outline';
      default:
        return 'chatbubbles-outline';
    }
  }

  /** Le chat AI hanno nome fisso su DB: la label mostrata segue la lingua UI. */
  recentChatTitleKey(kind: RecentChat['kind']): string | null {
    if (kind === 'narrator') return aiChatTitleKey('story');
    if (kind === 'archivist') return aiChatTitleKey('lore');
    return null;
  }

  recentChatTypeKey(kind: RecentChat['kind']): string | null {
    switch (kind) {
      case 'narrator':
        return 'homePage.recentTypeNarrator';
      case 'archivist':
        return 'homePage.recentTypeArchivist';
      case 'inn':
        return 'common.inn';
      case 'private':
        return 'homePage.recentTypePrivate';
      default:
        return null;
    }
  }
}
